/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Typography } from "@mui/material";

const DividerComponentEditor = () => {
    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='body1' color={"text.secondary"} className='simplicity-divider-parameters'>
                This component has no parameters.
            </Typography>
        </div>
    );
};

DividerComponentEditor.displayName = "DividerComponentEditor";
export { DividerComponentEditor };
